/* unplugin-vue-components disabled */import { render } from "./ExamQuizScore.vue?vue&type=template&id=31c07cf4&scoped=true&ts=true"
import script from "./ExamQuizScore.vue?vue&type=script&lang=ts"
export * from "./ExamQuizScore.vue?vue&type=script&lang=ts"

import "./ExamQuizScore.vue?vue&type=style&index=0&id=31c07cf4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c07cf4"]])

export default __exports__